// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3P7cN","content":"Consent_content__focN8","footer":"Consent_footer__hwfMt"};